import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { User } from "src/app/shared/models/user";
import * as _ from 'lodash';
import { debounceTime, map, tap } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { Helper } from "src/app/shared/utils/helper";
import { SelectList } from "src/app/shared/models/select-list";
import { EventService } from "src/app/shared/services/event.service";
declare var $: any

@Component({
    selector: 'app-navmenu',
    templateUrl: './nav-menu.html',
    styles: []
  })
export class NavmenuComponent implements OnInit{
  data: any = {};
  user: User;
  selectedBusiness$:Observable<{
    businessName: string;
    businessId: string;
    selected: boolean;
  }> = of(Helper.getSelectedBusiness)
  businesses$: Observable<Array<SelectList>> = of([]);

constructor(private authService: AuthService, private router: Router, private eventService:EventService){}

ngOnInit(): void {
  this.loadData();
}
  logout() {
    this.authService.logout();
    return this.router.navigate(['./login']);
  }

  private loadData() {
    this.authService.getUserDetails().pipe(
      tap((res: any) => {
          this.authService.saveUser(res);
          this.data = of(res.result);
          if(Helper.getSelectedBusiness ===null ||Helper.getSelectedBusiness.businessId===null){
            const {businessName, businessId} = res.result;
            Helper.setSelectedBusiness({businessName: `${businessId} -  ${businessName}`, businessId: businessId, selected: false})
          }
          this.onInitNav();
          this.businesses$ = this.authService.getLocalBusinessList();
          this.selectedBusiness$ = of(Helper.getSelectedBusiness);
      }),
      tap((o)=>this.getCompanyDetails(o))
    ).subscribe();
  }

  getCompanyDetails(user) {
    this.authService.getBusiness(user.result.businessId)
      .pipe(
        map((res: any) => res.result),
        tap((resp)=>{
          localStorage.setItem("business-details", JSON.stringify(resp))
        })
      ).subscribe();
  }

  getUserInfo(name) {
    return Helper.getUserObject(name);
  }

  getRoles(roles){
    const userRoles = Helper.getUserObject(roles);
    if (userRoles&&userRoles instanceof Array) {
      return userRoles.join(", ");
    }
    return "";
  }

  private onInitNav() {
    $().ready(function () {
      $('[data-widget="treeview"]').Treeview('init');
    })
  }

  onOnlyOwn(inoutValue){
    Helper.setSelectedBusiness({...Helper.getSelectedBusiness, selected: inoutValue});
    this.selectedBusiness$ = of(Helper.getSelectedBusiness);
    this.updateEventService();
  }

  handleSelected(method, {viewPortItems, searchTerm, isOpen}): void{
    switch (method) {
      case 'clear':
        this.selectedBusiness$ = of(Helper.getSelectedBusiness);
        break;
      case'close':
        if (viewPortItems.length > 0) {
          const { selected, value} = viewPortItems.find((f)=>f.selected);
        Helper.setSelectedBusiness({businessId: value.value, businessName: value.text, selected: Helper.getSelectedBusiness.selected});
        }
        this.updateEventService();
        break;
      case'search':
        if (searchTerm.length > 1 && viewPortItems.length < 2) {
          this.businesses$ = this.authService.getSelectListBusiness(searchTerm).pipe(
            debounceTime(300)
          );
        }
      break;
      default:
        break;
    }
  }

  updateEventService(): void{
    this.eventService.changeEvent(Helper.getSelectedBusiness);
  }

}
